import * as React from 'react';
import { clsx } from 'clsx';
import * as styles from './Station.css';
export function Station(_ref) {
  var stroke = _ref.stroke,
      rect = _ref.rect,
      active = _ref.active,
      onClick = _ref.onClick;
  var styleObject = React.useMemo(function () {
    return {
      width: rect.w,
      height: rect.h,
      borderColor: active ? undefined : stroke.color,
      borderWidth: "".concat(stroke.w / (active ? 2 : 1), "px"),
      left: rect.x,
      top: rect.y
    };
  }, [active, rect.h, rect.w, rect.x, rect.y, stroke.color, stroke.w]);
  return /*#__PURE__*/React.createElement("div", {
    role: "button",
    onClick: onClick,
    "data-testid": "station-pin",
    className: clsx(styles['pin'], active && styles['pin_active']),
    style: styleObject
  });
}